import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { sprintf } from 'sprintf-js';

import { environment } from '../../environments/environment';
import { DatatablesUtils } from 'app/_utils/datatables';
import { BaseService } from './base.service';

/** Grant applicant accounts (the Medexus grants portal's Applicants / Principals / Recipients). */
@Injectable()
export class GrantApplicantService extends BaseService {

  constructor(
    protected http: HttpClient,
  ) {
    super(http, `${environment.apiBaseUrl}/companies/%(company_id)s/grant_applicants`);
  }

  /**
   * DataTables server-side page. `params` carries recipient_type ('All' lists every type) and
   * the search filters: last_name, first_name, email, status, from_created_at, to_created_at.
   */
  listPage(urlParams: any, params: any, dtParams: any): Observable<{ contacts: any[]; total: number }> {
    const url = sprintf(this.baseUrl, urlParams);
    return this.http.get<{ contacts: any[]; total: number }>(url, {
      params: this.toHttpParams({
        ...params,
        ...DatatablesUtils.convertToApiParams(dtParams),
      }),
    });
  }
}
